import { BaseRepository } from '@/base/base-repository';

export interface GameStats {
	totalVolume: number;
	totalProfit: number;
	totalBets: number;
	gameActivity: { [game: string]: number };
}

export interface TopActivity {
	txId: string;
	betId: string;
	gambler: string;
	win: boolean;
	reward: number;
	stake: number;
	payout_multiplier: number;
	from: string;
	at: number;
	coin_type?: string;
}

class StatsRepository extends BaseRepository {
	async getGameStats(): Promise<GameStats> {
		try {
			const response = await this.httpClient({
				method: 'get',
				url: '/stats/game-stats',
			});
			return response;
		} catch (error) {
			console.warn('Failed to fetch game stats:', error);
			// Return fallback data
			return {
				totalVolume: 10000,
				totalProfit: 2500,
				totalBets: 1500,
				gameActivity: {
					lootbox: 400,
					coinflip: 350,
					dice: 300,
					limbo: 250,
					plinko: 200,
				},
			};
		}
	}

	async getTopActivities(limit: number = 20): Promise<TopActivity[]> {
		try {
			const response = await this.httpClient({
				method: 'get',
				url: `/stats/top-activities?limit=${limit}`,
			});
			return response;
		} catch (error) {
			console.warn('Failed to fetch top activities:', error);
			return [];
		}
	}

	async getTopActivitiesByGame(game: string, limit: number = 10): Promise<TopActivity[]> {
		try {
			const response = await this.httpClient({
				method: 'get',
				url: `/stats/top-activities?game=${encodeURIComponent(game)}&limit=${limit}`,
			});
			return response;
		} catch (error) {
			console.warn(`Failed to fetch top activities for ${game}:`, error);
			return [];
		}
	}

	async getRecentActivities(limit: number = 20): Promise<TopActivity[]> {
		try {
			const response = await this.httpClient({
				method: 'get',
				url: `/stats/recent-activities?limit=${limit}`,
			});
			return response;
		} catch (error) {
			console.warn('Failed to fetch recent activities:', error);
			return [];
		}
	}
}

export const statsRepository = new StatsRepository();
